/* ──────────────────────────────────────────────
 *  Sélecteur natif des inputs date / datetime-local.
 * ────────────────────────────────────────────── */

import type { SyntheticEvent } from 'react';

/**
 * Ouvre le calendrier natif dès le focus/clic n'importe où dans l'input, au lieu
 * d'exiger un clic sur la petite icône calendrier. `showPicker()` peut lever
 * (appel hors geste utilisateur, iframe cross-origin) et n'existe pas sur les
 * navigateurs anciens : dans ces cas on laisse le comportement natif (l'icône
 * reste cliquable).
 */
export const openNativeDatePicker = (event: SyntheticEvent<HTMLInputElement>): void => {
  try {
    event.currentTarget.showPicker?.();
  } catch {
    /* geste utilisateur absent ou picker déjà ouvert : l'icône native suffit. */
  }
};
